/**
 * Характеристики места и ряда приходят из `GET /aviabooking/flights/:id/add-ops`
 * пробел-разделённой строкой кодов ("W LS IE"), но поле необязательное: у мест из
 * ответа add-ops его может не быть вовсе. Читать `characteristics` напрямую нельзя —
 * `undefined.split` / `undefined.includes` срывает рендер карты мест целиком.
 */

const CHARACTERISTIC_LABELS: ReadonlyArray<readonly [code: string, label: string]> = [
    ['W', 'У окна'],
    ['A', 'У прохода'],
    ['LS', 'Левая сторона'],
    ['RS', 'Правая сторона'],
    ['CH', 'CH'],
    ['IE', 'IE'],
]

/** Разбирает строку характеристик в список кодов. Отсутствующее поле — пустой список. */
export const parseSeatCharacteristics = (characteristics?: string): string[] =>
    (characteristics ?? '').split(' ').filter(Boolean)

/** Есть ли у места/ряда код характеристики. Сравнение по целому коду, не по подстроке. */
export const hasSeatCharacteristic = (characteristics: string | undefined, code: string): boolean =>
    parseSeatCharacteristics(characteristics).includes(code)

/** Человекочитаемые подписи характеристик в фиксированном порядке. */
export const getSeatCharacteristicLabels = (characteristics?: string): string[] =>
    CHARACTERISTIC_LABELS
        .filter(([code]) => hasSeatCharacteristic(characteristics, code))
        .map(([, label]) => label)
